// Source unique des liens Stripe : ../../../shared/pricing.js.
// window.IndxPricing (posé par ce même fichier sur les pages HTML statiques)
// prime quand présent, pour rester en phase avec un hot-reload éventuel côté script.
import { PRICING } from '../../../shared/pricing.js';

function readPricing() {
  if (typeof window === 'undefined') return PRICING;
  return window.IndxPricing || PRICING;
}

const pricing = readPricing();

export const STRIPE_STARTER = pricing.starter;
export const STRIPE_PRO = pricing.pro;
export const STRIPE_PRO_ANNUAL = pricing.proAnnual || pricing.pro;
